import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/self-closing-comp */
import { useSelector } from 'react-redux';
import { organizationSelector } from '../state/orgIdState';
import { UnitsSoldWrappedWebComponent } from './cmd-ctr-units-sold';
import { VinTotalLeadsWrappedWebComponent } from './cmd-ctr-vin-total-leads';
import './WebComponentView.scss';
if (!customElements.get('cmd-ctr-units-sold')) {
    customElements.define('cmd-ctr-units-sold', UnitsSoldWrappedWebComponent);
}
if (!customElements.get('cmd-ctr-vin-total-leads')) {
    customElements.define('cmd-ctr-vin-total-leads', VinTotalLeadsWrappedWebComponent);
}
// This mimics the look of the bridge landing page for easy styling of web components
const WebComponentView = () => {
    const orgId = useSelector(organizationSelector);
    return (_jsxs("section", { id: "web-component-view", children: [_jsx("div", { className: "grid-item", children: _jsx("cmd-ctr-units-sold", { "common-org-id": orgId }) }), _jsx("div", { className: "grid-item", children: _jsx("cmd-ctr-vin-total-leads", { "common-org-id": orgId }) })] }));
};
export default WebComponentView;
